export default function ContactsIcon({
  className = 'buyin-icon',
  width = '16px',
  height = '16px',
}: {
  className?: string;
  width?: string;
  height?: string;
}) {
  return (
    <svg
      className="buyin-icon"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Icon/ic_contacts Copy</title>
      <g
        id="Icon/ic_contacts--Copy"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M12.1714286,0.5 C12.9604068,0.5 13.6,1.13959321 13.6,1.92857143 L13.6,14.0714286 C13.6,14.8604068 12.9604068,15.5 12.1714286,15.5 L2.4,15.5 L2.4,12.642 L1.35714286,12.6428571 C1.1598983,12.6428571 1,12.4829588 1,12.2857143 C1,12.0884697 1.1598983,11.9285714 1.35714286,11.9285714 L2.4,11.928 L2.4,8.357 L1.35714286,8.35714286 C1.1598983,8.35714286 1,8.19724455 1,8 C1,7.80275545 1.1598983,7.64285714 1.35714286,7.64285714 L2.4,7.642 L2.4,4.071 L1.35714286,4.07142857 C1.1598983,4.07142857 1,3.91153027 1,3.71428571 C1,3.51704116 1.1598983,3.35714286 1.35714286,3.35714286 L2.4,3.357 L2.4,0.5 L12.1714286,0.5 Z M14.3,1.92857143 C14.6865993,1.92857143 15,2.2419721 15,2.62857143 L15,14.0857143 C15,14.440097 14.7366564,14.7329725 14.3949859,14.7793241 L14.3,14.7857143 L14.3,1.92857143 Z M7.08061546,7.56185445 C6.70557676,7.46613597 6.32550456,7.69877443 6.23170045,8.08146699 C5.60944899,10.6316718 5.29832327,11.9165121 5.29832327,11.9359881 C5.29832327,12.1332327 4.99553381,12.6299332 5.87689439,12.6406062 C7.39883349,12.6372857 8.56777615,12.63474 9.38372235,12.632969 L9.71180155,12.6322575 C9.76287942,12.6321468 9.81215628,12.6320401 9.85963214,12.6319373 L10.2382878,12.6311191 C10.2749576,12.63104 10.3098265,12.6309649 10.3428943,12.6308937 L10.7436072,12.6300399 C10.755063,12.6300162 10.7647178,12.6299964 10.7725716,12.6299806 L10.7980824,12.6299332 C11.5524314,12.6299332 11.4381201,12.1273381 11.3912171,11.9359881 L10.4683149,8.08147237 C10.445792,7.98958573 10.4055841,7.90318772 10.3500311,7.82730641 C10.1186625,7.51127361 9.68002995,7.44646748 9.37030939,7.68254638 C9.08677164,7.89868429 8.74666851,8.00675325 8.35,8.00675325 C7.95333396,8.00675325 7.6132326,7.89868564 7.32969592,7.68255043 C7.25533274,7.62586464 7.17066347,7.58483677 7.08061546,7.56185445 Z M8.35,3.35714286 C7.38350169,3.35714286 6.6,4.15663438 6.6,5.14285714 C6.6,6.12907991 7.38350169,6.92857143 8.35,6.92857143 C9.31649831,6.92857143 10.1,6.12907991 10.1,5.14285714 C10.1,4.15663438 9.31649831,3.35714286 8.35,3.35714286 Z"
          id="contracts"
          fill="#FFFFFF"
        ></path>
      </g>
    </svg>
  );
}
